import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '@shared/supabase/client';
import { useSupabaseQuery } from '@shared/supabase/hooks';
import { SubTabBar } from './SubTabBar';
import DataHealth from './DataHealth';
import Maintenance from './Maintenance';
import FeedbackInbox from './FeedbackInbox';

/** Ops hub: data-health + maintenance + support inbox. Claims are approved in «Аккаунты»
 *  (PendingAccounts); the separate fallback tab that did the same via other RPCs is gone. */
export default function Ops() {
  const { t } = useTranslation('admin');
  const [tab, setTab] = useState<'health' | 'maintenance' | 'support'>('health');

  // Unhandled support tickets → badge on the "Поддержка" tab so new обращения don't sit unseen.
  const { data: newFeedback } = useSupabaseQuery<number>(
    ['feedback-new-count'],
    async () => {
      const res = await supabase.from('feedback').select('id', { count: 'exact', head: true }).or('status.eq.new,status.is.null');
      return { data: res.count ?? 0, error: res.error };
    },
  );

  return (
    <>
      <SubTabBar active={tab} onChange={(v) => setTab(v as 'health' | 'maintenance' | 'support')} tabs={[
        { v: 'health', label: t('opsTab.health', { defaultValue: 'Здоровье данных' }) as string },
        { v: 'maintenance', label: t('opsTab.maintenance', { defaultValue: 'Обслуживание' }) as string },
        { v: 'support', label: t('opsTab.support', { defaultValue: 'Поддержка' }) as string, badge: newFeedback || undefined, badgeUrgent: (newFeedback ?? 0) > 0 },
      ]} />
      {tab === 'health' ? <DataHealth /> : tab === 'maintenance' ? <Maintenance /> : <FeedbackInbox />}
    </>
  );
}
